/**
 * Extracts the numeric part from an assID string.
 * Example:
 *  - "ass001" -> 1
 *  - "ism_ass123" -> 123
 *  - "abc_ass0456" -> 456
 *
 * @param {string} assID - The assurance ID string.
 * @returns {number} - The numeric part of the assID.
 */
export function extractAssIDNumber(assID: string): number {
    const match = assID.match(/ass(\d+)$/i); // Case-insensitive match
    if (match) {
        return parseInt(match[1], 10);
    }
    return 0; // Default to 0 if no match found
}